import { useIsFeedLoaded } from '../../store/selectors';
import { useCasinoSettings } from '../useCasinoSettings';

export const useCollectionsFeedLoadingData = (casinoType) => {
  const { collectionFeed: collectionsFeedName } = useCasinoSettings(casinoType);
  const isCollectionsFeedLoaded = useIsFeedLoaded(collectionsFeedName);
  const isCollectionsFeedLoading = collectionsFeedName
    ? !isCollectionsFeedLoaded
    : false;

  return { isCollectionsFeedLoaded, isCollectionsFeedLoading };
};
